import Extension from "../base/extension";

class Nav extends Extension {
  #section;
  #activeNavLinks = new Set();
  #observer = null;

  constructor(name) {
    super(name);
    
    // Capture active nav links immediately (before Bootstrap initializes)
    document.querySelectorAll('nav[aria-label="Main navigation"] .nav-link.active').forEach(link => {
      this.#activeNavLinks.add(link);
    });
  }

  init() {
    this.#section = document.querySelector('.section-header');
    this.setupScrollListener();
    this.setupActiveStatePreservation();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  }
  
  setupActiveStatePreservation() {
    // Restore active classes after Bootstrap initializes
    const restoreActiveStates = () => {
      this.#activeNavLinks.forEach(link => {
        if (!link.classList.contains('active')) {
          link.classList.add('active');
        }
      });
    };
    
    // Run immediately
    setTimeout(restoreActiveStates, 0);
    
    // Also run after a small delay to catch any late initializations
    setTimeout(restoreActiveStates, 100);
    
    // Watch for class removals and restore immediately
    this.#observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const link = mutation.target;
          if (this.#activeNavLinks.has(link) && !link.classList.contains('active')) {
            link.classList.add('active');
          }
        }
      });
    });
    
    // Observe all nav links
    this.#activeNavLinks.forEach(link => {
      this.#observer.observe(link, { attributes: true, attributeFilter: ['class'] });
    });
  }

  onScrollDown(e) {
    if(e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-up');
      this.#section.classList.add('scrolled-down');
    }
  }

  onScrollUp(e) {
    if(e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-down');
      this.#section.classList.add('scrolled-up');
    }
  }

  setupScrollListener() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(e){
      let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      let difference = Math.abs(st - lastScrollTop);
      // Add a 'tolerance' to prevent microscrolls from retriggering (e.g. on touch devices, there's usually a very small scroll up after scrolling down)
      if (st > lastScrollTop){
        let event = new CustomEvent("interaction:down-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      } else {
        let event = new CustomEvent("interaction:up-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default Nav;